module.exports = __webpack_public_path__ + "static/img/home_activity.ceae978.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icons/home_activity.jpeg
// module id = Vck5
// module chunks = 4